export default "__VITE_ASSET__CTJRm0lo__"